import axios from 'axios'

const state = {
  canLoadMore: false,
  archivedConversations: null
}

const actions = {
  fetchArchivedConversations: async ({ commit }, params) => {
    if (params.page === 0) {
      commit('SET_ARCHIVED_CONVERSATIONS', null)
    }
    commit('SET_CAN_LOAD_MORE', true)
    const url = '/archived-conversations'
    const res = await axios.get(url, { params })
    const archivedConversations = res.data
    if (res.status === 200 && archivedConversations.length) {
      if (params.page === 0) {
        commit('SET_ARCHIVED_CONVERSATIONS', archivedConversations)
      } else {
        commit('SET_MORE_ARCHIVED_CONVERSATIONS', archivedConversations)
      }
    } else {
      commit('SET_CAN_LOAD_MORE', false)
    }
  }
}

const mutations = {
  SET_ARCHIVED_CONVERSATIONS: (state, archivedConversations) => {
    state.archivedConversations = archivedConversations
  },
  SET_MORE_ARCHIVED_CONVERSATIONS: (state, archivedConversations) => {
    state.archivedConversations = [...state.archivedConversations, ...archivedConversations]
  },
  SET_CAN_LOAD_MORE: (state, status) => {
    state.canLoadMore = status
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
